var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"treelistitem"},[_c('el-tree',{attrs:{"data":_vm.data,"node-key":"id","accordion":"","highlight-current":"","render-content":_vm.renderContent},on:{"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }